import React from 'react';
import './UserAvatar.css';

function UserAvatar({ user, size = 'medium', hasUnreadActivity = false }) {
  const sizeClass = {
    small: 'avatar-small',
    medium: 'avatar-medium',
    large: 'avatar-large'
  }[size];

  const getInitials = (name) => {
    if (!name) return '?';
    return name
      .split(' ')
      .map(word => word[0])
      .join('')
      .toUpperCase()
      .slice(0, 2);
  };

  // If no user or no displayName, show a default avatar
  if (!user || (!user.photoURL && !user.displayName)) {
    return (
      <div className={`user-avatar ${sizeClass} ${hasUnreadActivity ? 'has-activity' : ''}`}>
        <span>?</span>
        {hasUnreadActivity && <div className="activity-indicator" />}
      </div>
    );
  }

  // Now we know we'll always have a photoURL (either real or generated)
  // because of our databaseService changes
  return (
    <div className={`avatar-container ${sizeClass} ${hasUnreadActivity ? 'has-activity' : ''}`}>
      <div className="activity-ring"></div>
      <div className="avatar-wrapper">
        <img 
          src={user?.photoURL || '/images/default-avatar.png'} 
          alt={user?.name || 'User avatar'} 
          className="avatar-image"
          onError={(e) => {
            // If image fails to load, show initials
            e.target.style.display = 'none';
            e.target.nextElementSibling.style.display = 'flex';
          }}
        />
        <div className="initials-fallback" style={{ display: 'none' }}>
          {getInitials(user.displayName)}
        </div>
        {hasUnreadActivity && (
          <div className="activity-dot"></div>
        )}
      </div>
    </div>
  );
}

export default UserAvatar; 